import { styled, css } from "styled-components";
import Wallpaper from '../../Assets/Tab_background3.jpg';

export const Workbody = styled.div`
height:100vh;
width:calc(100% - 70px);
display:flex;
flex-direction:row;
justify-content:center;
align-items:center;
padding-left:70px;

@media only screen and (max-width: 900px) {
    padding-bottom:15vh;
    flex-direction:column;
    padding-left:70px;
    width:90%;
    height:110vh;
}
@media only screen and (max-width: 700px) {
    flex-direction:column;
    padding-left:0;
    width:100%;
    height:110vh;
}
`

export const Left = styled.div`
width:30%;
height:60%;
display:flex;
flex-direction:column;
justify-content:space-between;
align-items:center;

h1{
    margin:0;
    line-height:1;
    font-size:5rem;
    color:white;
    font-weight:700;
    font-family: Franklin Ghotics Medium;
    margin-bottom:50px;
}
span{
    font-weight:400;
}

img{
    height:400px;
    width:400px;
    filter: drop-shadow(16px 7px 8px rgba(108, 122, 137,.7));
}

@media only screen and (max-width: 900px) {
    width:100%;
    padding-bottom:40px;
    height:max-content;

    h1{
        font-size:3rem;
        font-size:4rem;
        margin-bottom:0px;
        text-align:center;
    }
        img{
        display:none;
    }
}

@media only screen and (max-width: 700px) {
margin-top:80px;

 h1{
        font-size:2.5rem;
    }
}

@media only screen and (max-width: 350px) {
margin-top:80px;

 h1{
        font-size:2.1rem;
    }
}
`

export const Right = styled.div`
position:relative;
width:60%;
height:90%;

display:flex;
justify-content:center;
align-items:center;

@media only screen and (max-width: 900px) {
    width:100%;
}

`


export const Screen = styled.div`
position:relative;
width:95%;
height:90%;
background:white;
border-radius:16px;
border:5px solid grey;
border-left:2px solid grey;
border-top: 2px solid grey;

// background-image:url(${Wallpaper});
// background-size: cover;
//   background-position: center;

display:flex;
justify-content:space-around;
padding:20px;

@media only screen and (max-width: 700px) {
   flex-direction:column-reverse;
   height:95vh;
   padding:5px;
   width:90%;
   }

`


export const Projectcss = css`
// position:absolute;
width:150px;
height:100px;
background:white;
border-radius:8px;
border:1px solid black;
top:2%;
right:2%;
// transform:skew(-12deg,0deg);
// box-shadow: 0px 10px 10px 0px grey;

display:flex;
justify-content:center;
align-items:center;
img{
    width:94%;
    height:92%;
    background:olive;
}



&:hover{
    transform:  scale(1.1);
    box-shadow: 0px 15px 30px 0px white;

}

@media only screen and (max-width: 900px) {
 right:10%;
 width:75%;

 &:hover{
    transform:scale(1.1);
    box-shadow: 0px 15px 30px 0px white;
}
}

@media only screen and (max-width: 700px) {
    right:12.5%;
    width:50px;
    height:50px;

    img{
    width:94%;
    height:92%;
    // background:olive;
}
   }

`

export const Project1 = styled.div`
${Projectcss}

${props => props.pstyle.top &&
    css`
    top:${props.pstyle?.top}%;
    right:${props.pstyle?.right}%;
`}
`

export const Tabs = styled.div`
display:flex;
flex-direction:column;
justify-content:start;
gap:20px;
padding-right:20px;

@media only screen and (max-width: 700px) {
   flex-direction:row;
   justify-content:space-around;

   }
`

export const Video = styled.div`
width:100%;
height:95%;
`

export const LINKBAR = styled.div`
width:100%;
height:5%;
border-radius:16px;
background:rgba(128,128,128,0.15);
text-align:center;
a{
text-decoration: none; 
}
`

export const VLC = styled.div`
width:100%;
height:93%;
margin-top:2%;

.video-player {
  height: 100%;
  width: 100%;
  object-fit: fill; /* keeps aspect ratio nicely */
}
`
export const BottomMenu = styled.div`
position:absolute;
width:100%;
background:rgba(128,128,128,0.15);
border-bottom-left-radius: 12px;
border-bottom-right-radius: 12px;
height:6%;
bottom:0;

display:flex;
justify-content:space-around;
align-items:center;

@media only screen and (max-width: 700px) {

display:none;

}
`